import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import NavbarComp from '../components/NavbarComp';
import FooterComp from '../components/FooterComp';
import { useNavigate } from 'react-router-dom'

const mapStateToProps = (state) => {
  return {
    auth: state.auth
  }
}


const mapDispatchToProps = dispatch => ({

});


const NavigateOnStateChange = ({ shouldNavigate, to }) => {
  const navigate = useNavigate();

  React.useEffect(() => {
    if (shouldNavigate) {
      navigate(to);
    }
  }, [shouldNavigate, navigate, to]);

  return null;
};

class LoginDirection extends PureComponent {

  constructor(props) {
    super(props);

    this.state = {
      shouldNavigate: false,
      path: null
    }
  }

  handleDirection = (path) => {
    this.setState({
      shouldNavigate: true,
      path
    })
  }

  componentDidMount() {
    if (!this.props.auth.baseline) {
      this.setState({
        shouldNavigate: true,
        path: "/alertness"
      })
    }
  }

  render() {
    return <Fragment>

      <NavbarComp access_token={true}/>
      <div className="logindirection">
        <div className="content">
          <p className='label'>Is this the beginning of your shift?</p>
          <p className='direction-true' onClick={() => this.handleDirection("/daily-questionnaire")}>YES, THIS IS THE BEGINNING OF MY SHIFT!</p>
          <p className='direction-false' onClick={() => this.handleDirection("/dashboard")}>NO, I AM JUST LOGGING IN TO MY ACCOUNT</p>
        </div>
      </div>
      <FooterComp />
      <NavigateOnStateChange shouldNavigate={this.state.shouldNavigate} to={this.state.path} />

    </Fragment>
  }
}

LoginDirection.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(LoginDirection);
